module.exports = __webpack_public_path__ + "static/classics-logo-cc0dc5e9bd5752847db2b76b26876db8.png";